<!-- 建管平台 -->
<template>
  <div class="management-index">
    <!-- :posterImg="bannerInfo.posterImg"
      :videoUrl="bannerInfo.videoUrl" -->
    <SecondaryBanner
      :height="bannerInfo.height"
      :icon="bannerInfo.icon"
      :iconText="bannerInfo.iconText"
      :title="bannerInfo.title"
      :bgImage="bannerInfo.bgImage"
      :videoUrl="bannerInfo.videoUrl"
    />
    <AnchorTabs ref="managementAnchorTabsRef" :tabList="tabList" />
    <div
      id="Overview"
      class="content"
      v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
    >
      <div class="title">
        什么是 <span>{{ overview.title }}</span
        >？
      </div>
      <div class="desc text-wrap">
        <div
          v-for="(item, index) in overview.description"
          :key="'overview_' + index"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div id="Function" class="content">
      <div
        class="title"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <span>{{ Function.title }}</span>
      </div>
      <el-row :gutter="68">
        <el-col
          :xs="24"
          :sm="24"
          :md="12"
          :lg="8"
          :xl="8"
          v-for="(item, index) in Function.list"
          :key="index"
        >
          <div
            class="item"
            v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
          >
            <div class="item-title">{{ item.title }}</div>
            <div class="item-desc text-wrap">
              <div
                v-for="(e, i) in item.description"
                :key="'func_' + index + '_' + i"
              >
                {{ e }}
              </div>
            </div>
            <img class="c_img numPic" :src="item.iconUrl" alt="" />
            <img class="c_img illustration" :src="item.imgUrl" alt="" />
          </div>
        </el-col>
      </el-row>
    </div>
    <div id="Highlights" class="content">
      <div
        class="title"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
      >
        <div class="verticalLine"></div>
        <span>{{ Highlights.title }}</span>
      </div>
      <div
        class="card"
        v-scroll-animate="{ animation: 'fadeInUp', delay: 100 }"
        v-for="(item, index) in Highlights.list"
        :key="index"
      >
        <div class="left"></div>
        <div class="center">
          <div class="info">
            <div class="line"></div>
            <div class="card-title">{{ item.title }}</div>
            <div class="card-desc" v-html="item.description"></div>
          </div>
          <img class="c_img" :src="item.imgUrl" alt="" srcset="" />
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div id="Cases">
      <Cases></Cases>
    </div>
    <div id="Cooperate">
      <!-- :bgImage="
          require('@/assets/images/intelligentImg/bg-advertising-management.png')
        " -->
      <ProductGet
        title="根据您的业务需要定制数字建设管理平台！"
        subTitle="狄诺尼智能建造，为您带来一站式设计解决方案"
        :showWhiteBg="true"
        :downLoadBtn="{
          label: '下载产品手册',
          fileUrl: '/download?anchor=manual',
          show: true,
        }"
        :contactBtn="{
          label: '让销售人员联系您',
        }"
      />
    </div>
  </div>
</template>

<script>
import SecondaryBanner from "@/components/SecondaryBanner.vue";
import AnchorTabs from "@/components/AnchorTabs.vue";
import ProductGet from "@/components/ProductGet.vue";
import Cases from "./cases.vue";
import { prefix } from "@/utils/env";
export default {
  components: { SecondaryBanner, AnchorTabs, ProductGet, Cases },
  data() {
    return {
      bannerInfo: {
        // height: "896px", //有切换视频的按钮时，高度为896px
        height: "845px",
        bgImage: require("@/assets/images/intelligentImg/bg-secondary-banner-management.png"),
        icon: require("@/assets/images/intelligentImg/icon-secondary-banner-jgpt-logo.png"),
        iconText: "数字建设管理平台",
        title: "集成高效管理，赋能智慧建设，引领行业数字化转型",
        // pictureUrl: require("@/assets/images/intelligentImg/bg-secondary-banner-management-posterImg.png"),
        posterImg: require("@/assets/images/intelligentImg/bg-secondary-banner-management-posterImg.png"),
        videoUrl: `${prefix}/static/video/management.mp4`,
      },
      tabList: [
        {
          name: "全部",
          value: "Overview",
        },
        {
          name: "功能",
          value: "Function",
        },
        {
          name: "亮点",
          value: "Highlights",
        },
        {
          name: "案例",
          value: "Cases",
        },
        {
          name: "合作",
          value: "Cooperate",
        },
      ],
      overview: {
        title: "数字建设管理平台",
        description: [
          "数字建设管理平台是针对交通工程建设周期内各参与建设单位协同管理和办公的工程建设数字化综合管理平台 。聚焦工程建设中的进度质量、安全、计量、档案等核心业务，深度融合 BIM 技术实现工程建设项目的数字孪生，为交通工程建设数字化转型提供全新的技术手段。",
          "· 平台提供全面标准化的项目管理业务功能；实现三控、三管、一协调;",
          "· 自主研发的BIM+GIS引擎解决了超大场景精细化模型层面的承载能力和运行效率;",
          "· 基于WBS打通各业务，积累工程全要素信息，向管养阶段传递数据，进行数字化竣工交付。",
          "系统采用“三端一云”的软件架构，运用新一代信息技术和数字孪生技术，实现与施工现场管理的深度融合，打造实时数据驱动数字孪生平台和智慧建设协同管理平台。",
        ],
      },
      Function: {
        title: "平台功能有哪些？",
        list: [
          {
            title: "BIM协同",
            description: ["核心数据BIM模型同步展示", "工程管理三维可视化"],
            iconUrl: require("@/assets/images/intelligentImg/icon-function-1.png"),
            imgUrl: require("@/assets/images/intelligentImg/bg-function-1.png"),
          },
          {
            title: "计划进度",
            description: ["项目计划编制 丨 实际进度反馈", "进度定期航拍对比"],
            iconUrl: require("@/assets/images/intelligentImg/icon-function-2.png"),
            imgUrl: require("@/assets/images/intelligentImg/bg-function-2.png"),
          },
          {
            title: "质量管理",
            description: [
              "工序报验 丨 材料溯源",
              "隐患管理（随手拍） 丨 质检资料报审",
            ],
            iconUrl: require("@/assets/images/intelligentImg/icon-function-3.png"),
            imgUrl: require("@/assets/images/intelligentImg/bg-function-3.png"),
          },
          {
            title: "安全管理",
            description: [
              "安保体系 丨 风险管控 丨 危大工程",
              "隐患排查 丨 人员、设备管理",
            ],
            iconUrl: require("@/assets/images/intelligentImg/icon-function-4.png"),
            imgUrl: require("@/assets/images/intelligentImg/bg-function-4.png"),
          },
          {
            title: "计量支付",
            description: ["合同管理 丨 计量支付", "变更管理"],
            iconUrl: require("@/assets/images/intelligentImg/icon-function-5.png"),
            imgUrl: require("@/assets/images/intelligentImg/bg-function-5.png"),
          },
          {
            title: "电子档案",
            description: [
              "质量资料 丨 试验资料 丨 统计分析",
              "电子签章 丨 自动化流转 丨 实时化归集",
            ],
            iconUrl: require("@/assets/images/intelligentImg/icon-function-6.png"),
            imgUrl: require("@/assets/images/intelligentImg/bg-function-6.png"),
          },
        ],
      },
      Highlights: {
        title: "平台亮点有哪些？",
        list: [
          {
            title: "基于统一身份认证综合管理平台",
            description:
              "基于统一身份认证，提供用户认证、单点登录、权限管理等功能，实现应用集成和用户信息的集中管理。它通过增强安全性、数据管理、业务创新、客户体验和组织协同，提高企业运营效率和决策能力，同时降低成本和资源消耗。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-1.png"),
          },
          {
            title: "基于BIM全方位数字孪生",
            description:
              "利用建筑信息模型（BIM）技术，结合物联网（IoT）、大数据、云计算等技术，创建一个与实体建筑完全相同的数字副本，这个数字副本能够实时反映实体建筑的状态和性能，实现数据的集成和分析，以优化建筑的全生命周期管理。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-2.png"),
          },
          {
            title: "基于统一WBS/EBS编码标准",
            description:
              "为工程构件创建了唯一的、可机器识别的编码，从而实现了不同业务领域的数据互联互通。通过这种方式，可以节省管理成本、提高项目管理的数字化水平，并有效地归集建设期的数据资产，为高速公路等基础设施的数字化转型打下基础。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-3.png"),
          },
          {
            title: "多维管理业务深度融合",
            description:
              "整合项目的成本、进度、质量、安全等多个维度的数据，通过统一的编码标准和数据模型，实现了不同业务系统之间的无缝对接。不仅提高了管理效率，还增强了决策的准确性，促进了项目全生命周期的优化管理。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-4.png"),
          },
          {
            title: "模型瓦片化分层加载技术",
            description:
              "模型瓦片化分层加载技术通过将BIM模型分割成多个瓦片，并根据需要动态加载，显著提高了模型的加载效率和交互性能，同时支持了多维管理业务的深度融合，为数字建设管理平台提供了强大的技术支持。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-5.png"),
          },
          {
            title: "融合纸云同步+电子签章+ 区块链电子档案应用",
            description:
              "平台通过集成纸云同步、电子签章和区块链电子档案应用，实现了数据的高效管理与安全存储。纸云同步技术使得数据同步上云，便于集中管理和访问；电子签章确保了流程审批的合规性和安全性；区块链技术则为电子档案提供了不可篡改的存证验真和历史追溯，增强了数据的真实性和安全性。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-6.png"),
          },
          {
            title: "口袋化工程管理",
            description:
              "口袋化工程管理功能允许通过移动设备随时随地访问和监控工程项目，实现实时数据更新、任务分配、文档管理、团队沟通和安全质量监控。这种移动化的管理方式提高了项目管理的效率和响应速度，同时增强了团队协作和决策的及时性。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-7.png"),
          },
          {
            title: "沉浸式大屏综合展示",
            description:
              "通过大屏幕高清显示、多屏联动、交互式操作和实时数据展示，提供了一个集中的监控和指挥中心。能够集成多种数据源，支持情境模拟和智能分析，帮助管理者进行高效的项目管理和快速决策。",
            imgUrl: require("@/assets/images/intelligentImg/bg-highlights-8.png"),
          },
        ],
      },
      anchor: "",
    };
  },
  mounted() {
    this.anchor = this.$route.query.anchor;
    if (this.anchor) {
      // 需等待数据调用完成，页面渲染完成
      setTimeout(() => {
        this.$refs.managementAnchorTabsRef.handleTabClick(this.anchor);
      }, 500);
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.management-index {
  width: 100%;
  height: 100%;
  background: #fff;
  .content {
    width: 1049px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    .title {
      font-size: 24px;
      color: #000000;
      line-height: 24px;
      margin-bottom: 24px;
      > span {
        font-weight: 600;
      }
    }
    .desc {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 32px;
      text-align: justify;
      > div {
        text-indent: 2em;
      }
    }
    .item {
      margin-bottom: 26px;
      opacity: 0;
      position: relative;
      .item-title {
        margin-bottom: 16px;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        line-height: 30px;
      }
      .item-desc {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        margin-bottom: 24px;
      }
      .illustration {
        width: 100%;
        height: 160px;
      }
      .numPic {
        width: 53px;
        height: 32px;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
  #Highlights.content {
    width: 1200px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    .title {
      height: 64px;
      margin-bottom: 0;
      padding-left: 75px;
      display: flex;
      justify-content: flex-start;
      .verticalLine {
        width: 1px;
        height: 64px;
        border-right: 1px solid #f5f5f5;
      }
    }
    .card {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #f5f5f5;
      opacity: 0;
      &:last-child {
        border-bottom: 0;
      }
      .left,
      .right {
        width: 76px;
        height: 248px;
      }
      .left {
        border-right: 1px solid #f5f5f5;
      }
      .right {
        border-left: 1px solid #f5f5f5;
      }
      .center {
        flex: 1;
        display: flex;
        justify-content: space-between;
        padding: 24px 44px 24px 44px;
        .info {
          position: relative;
          .card-title {
            width: 520px;
            font-weight: 600;
            font-size: 20px;
            color: #333333;
            line-height: 24px;
            margin-bottom: 12px;
          }
          .card-desc {
            width: 520px;
            height: 140px;
            font-weight: 400;
            font-size: 16px;
            color: #666666;
            line-height: 28px;
            text-align: justify;
          }
          .line {
            position: absolute;
            width: 24px;
            height: 4px;
            background: #2f69f2;
            top: 10px;
            left: -56px;
          }
        }
      }
      img {
        width: 360px;
        height: 200px;
      }
    }
  }
  #Cases {
    width: 100%;
    height: 584px;
  }
}
</style>
